import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import SpeakerCardView from './View';
import { speakerCardSchema } from './schema';

const SpeakerCardEdit = (props) => {
  const { data, block, onChangeBlock, selected, properties } = props;
  const schema = speakerCardSchema();

  return (
    <>
      <SpeakerCardView data={data} properties={properties} />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id, value) => {
            onChangeBlock(block, { ...data, [id]: value });
          }}
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

export default SpeakerCardEdit;
